import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import './Layout.css'

function Layout() {
    const { user, userProfile, logout } = useAuth()
    const navigate = useNavigate()

    const handleLogout = async () => {
        try {
            await logout()
            navigate('/login')
        } catch (error) {
            console.error('Logout failed:', error)
        }
    }

    return (
        <div className="layout">
            {/* Header */}
            <header className="header">
                <div className="header-container">
                    <NavLink to="/" className="logo">
                        <span className="logo-text">
                            Wante<span className="logo-lens">🔍</span>Cup
                        </span>
                    </NavLink>

                    <nav className="nav">
                        <NavLink to="/identify" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                            Identify
                        </NavLink>
                        <NavLink to="/history" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                            My Collection
                        </NavLink>
                        <NavLink to="/catalog" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                            Catalog
                        </NavLink>
                        {userProfile?.role === 'admin' && (
                            <NavLink to="/admin" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                                Admin
                            </NavLink>
                        )}
                    </nav>

                    <div className="header-right">
                        <NavLink to="/profile" className="profile-link">
                            <div className="profile-avatar">
                                {user?.email?.charAt(0).toUpperCase()}
                            </div>
                        </NavLink>
                        <button onClick={handleLogout} className="btn-logout">
                            Sign Out
                        </button>
                    </div>
                </div>
            </header>

            {/* Access Level Banner */}
            {userProfile && (
                <div className={`access-banner ${userProfile.role === 'paid' ? 'paid' : 'free'}`}>
                    <span>
                        {userProfile.role === 'paid'
                            ? '✨ Premium Access'
                            : '🔓 Free Access - Upgrade for unlimited identifications'}
                    </span>
                </div>
            )}

            {/* Main Content */}
            <main className="main-content">
                <Outlet />
            </main>

            {/* Footer */}
            <footer className="footer">
                <div className="footer-container">
                    <p className="footer-text">
                        © 2024 WantedCup. Vintage Tableware Identification & Appraisal.
                    </p>
                    <p className="footer-disclaimer">
                        Identification and price estimates are provided for informational purposes only
                        and do not constitute an expert appraisal.
                    </p>
                </div>
            </footer>
        </div>
    )
}

export default Layout
